module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-tabletPro-en.daf76bdc.png";